// Build-time configuration. Vite inlines `import.meta.env.VITE_*` into the bundle, so each value
// comes from `.env.development` (vite dev) / `.env.production` (vite build) or from the process
// environment, which wins over both files (docker-compose, CI). A missing value is a build error
// (see vite.config.ts); this check keeps the runtime equally strict.

function requireEnv(name: string, value: string | undefined): string {
  if (value === undefined || value.trim() === "") {
    throw new Error(`Required environment variable ${name} is not set`);
  }
  return value;
}

export const API_BASE_URL = requireEnv("VITE_API_BASE_URL", import.meta.env.VITE_API_BASE_URL);
